class ArticleAnchor extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() { 
// document.addEventListener("DOMContentLoaded", function () {
  const anchorSection = document.querySelector(".article-anchor p");
  const headingElement = document.querySelector(".article-text-content h4");
  const anchorList = document.querySelector(".article-anchor ul");
  const customList = document.querySelector(".custom-list");
  const textContent = document.querySelector(".article-text-content");
  const articleContent = document.querySelector(".article-content");

  // Set default state: hidden
  if (textContent) textContent.style.display = "none";

  if (!customList) {
      console.log("Custom list element not found!");
  }
  if (anchorSection && headingElement) {
    headingElement.textContent = anchorSection.textContent;
  }

  if (!anchorList || !customList) return; // Exit if required elements are missing

  const icons = [
    "https://cdn.shopify.com/s/files/1/0059/6915/0025/files/anchor_icon1.png?v=1740556205",
    "https://cdn.shopify.com/s/files/1/0059/6915/0025/files/anchor_icon2.png?v=1740556204",
    "https://cdn.shopify.com/s/files/1/0059/6915/0025/files/anchor_icon3.png?v=1740556204",
    "https://cdn.shopify.com/s/files/1/0059/6915/0025/files/anchor_icon4.png?v=1740556204",
  ];

  customList.innerHTML = ""; // Clear existing content

  anchorList.querySelectorAll("li").forEach((item, index) => {
    const li = document.createElement("li");
    li.classList.add("list-item");
      
    // Create <img> for the icon
    li.innerHTML = `
      <img src="${icons[index % icons.length]}" alt="Icon" width="20" height="20">
      <span>${item.innerHTML}</span>
      `;

      // Append <li> to custom list
    customList.appendChild(li);
  });

  if (textContent) {
    if (customList.children.length > 0) {
        textContent.style.display = "block"; // Show if anchors exist
        articleContent.style.flex = "0 0 80%";
        articleContent.style.width = "80%";
    } else {
        textContent.style.display = "none"; // Hide if no anchors
        articleContent.style.flex = "0 0 100%";
        articleContent.style.width = "100%";
    }
}

  // Event delegation for smooth scrolling
  document.addEventListener("click", function (event) {
      // Only trigger for <li> inside .custom-list
    const clickedItem = event.target.closest(".custom-list li");
    if (!clickedItem) return;

    // Find <a> inside clicked <li>
    const anchorTag = clickedItem.querySelector("a");
    if (!anchorTag) return;

    event.preventDefault();
      
    // Remove "#" from href
    const targetId = anchorTag.getAttribute("href")?.substring(1);
    if (!targetId) return;

    const scrollTarget = document.getElementById(targetId);
    if (scrollTarget) {
      window.scrollTo({
        top: scrollTarget.getBoundingClientRect().top + window.scrollY - 170,
        behavior: "smooth",
      });
    }
  });
  // });
}
}
customElements.define("article-anchor", ArticleAnchor);